import { FC, useCallback, useEffect, useState } from "react";

import IPagamentoProps from "pages/Pagamento/IPagamentoProps";

import { Skeleton, Spin } from "antd";

import "./Pagamento.css";

import { IPagamento, IPaymentSendRequest } from "core/interfaces/data/IAssistitoRequest";
import { AssistitoRepository } from "core/data";
import i18n from "utils/i18n";
import { PagesEnum } from "types/PagesEnum";
import { formStep } from "types/StepEnums";
import { IPreventivoData } from "core/interfaces/data/IPagamentoRequest";

import RiepilogoRepository from "core/data/RiepilogoRepository";
import {  IResultPrenotazioneDataSlice } from "core/redux/features/dataForm/dataFormSliceInterfaces";

import {  setResoultPrenotazione } from "core/redux/features/dataForm/dataFormSlice";

import { getReduxResultPrenotazioneData } from "utils/ReduxUtils";
import { PaymentMode } from "types/PaymentMode";
import { getCurrentPageName, pagesEnumFromPageName } from "utils/NavigationHelper";
import NavigationManager from "utils/NavigationManager";
import Riepilogo from "components/Riepilogo/Riepilogo";
import GestionePagamenti from "components/GestionePagamenti/GestionePagamenti";
import { IModalitaPagamentoForm } from "core/interfaces/data/IModalitaPagamentoForm";
import SceltaModalitaPagamento from "components/SceltaModalitapagamento/SceltaModalitapagamento";
import { Enhanced } from "utils/ReactUtils";

const Pagamento: FC<IPagamentoProps> = ({ OnFinishSession,sessionInfo,dispatch,t ,dataForm,location}) => {
	const { GoToPage } = NavigationManager(sessionInfo);

	const [loading, setLoading] = useState<boolean>(true);
	const [paying, setPaying] = useState<boolean>(false);
	const [newPrenotazione, setNewPrenotazione] = useState<boolean>(false);

	const [paymentMode, setPaymentMode] = useState<PaymentMode>();

	const [preventivoData, setPreventivoData] = useState<IPreventivoData>();

	const populatePreventivo = useCallback(
		async (idPrev: number, paymentMode?: PaymentMode) => {
			const prev = await RiepilogoRepository.getPreventivo({
				IdSessione: sessionInfo.sessione?.idSessione,
				culture: i18n.language,
				IdPreventivo: idPrev,
			});

			setPreventivoData(prev);

			var res = getReduxResultPrenotazioneData(
				false,
				{
					IdPreventivo: idPrev,
					Matricola: prev?.Matricola!,
					CodServizio: 0,
					DestPrestazione: prev?.Nominativo!,
					CodPai: prev?.CodPai!,
					MailInviata: dataForm.resultPrenotazione?.ResPrenotazione?.MailInviata ?? true,
				},
				prev?.DettagliPreventivo,
				paymentMode ?? dataForm.resultPrenotazione?.PaymentMode
			);

			dispatch(setResoultPrenotazione(res));

			setLoading(false);
		},
		[dataForm.resultPrenotazione?.PaymentMode, dataForm.resultPrenotazione?.ResPrenotazione?.MailInviata, dispatch, sessionInfo.sessione?.idSessione]
	);

	const getSender = (): PagesEnum => {
		return pagesEnumFromPageName[getCurrentPageName(location.state.from.pathname)];
	};

	useEffect(() => {
		let currentLocationState = location?.state ;
		if (dataForm.resultPrenotazione?.PaymentSuccess === undefined) {
			if (currentLocationState) {
				setLoading(true);
				if (!preventivoData) {
					var idPrev = currentLocationState.idPreventivo;
					if (dataForm.resultPrenotazione?.ResPrenotazione?.IdPreventivo) {
						setNewPrenotazione(true);
						populatePreventivo(dataForm.resultPrenotazione.ResPrenotazione.IdPreventivo);
					} else if (idPrev) {
						populatePreventivo(idPrev);
						setNewPrenotazione(false);
					}
				} else {
					setLoading(false);
				}
			}
			if (dataForm.resultPrenotazione?.PaymentMode) {
				setPaymentMode(dataForm.resultPrenotazione?.PaymentMode);
			}
		}
	}, [dataForm.resultPrenotazione, location?.state, populatePreventivo, preventivoData]);

	/**
	 * Quando si salvano i dati del pagamento sia che sia effettuato digitalmente o che venga
	 * fatto successivamente
	 *
	 */

	const OnStrypePaymentDone = async (pagamento: IPagamento) => {
		const res: IResultPrenotazioneDataSlice = { ...dataForm!.resultPrenotazione };
		res!.PaymentMode = pagamento.TipoPagamento;
		res!.PaymentSuccess = pagamento.Success;
		res!.ResPrenotazione = dataForm?.resultPrenotazione?.ResPrenotazione;
		res!.IdTransazione = pagamento.TransactionID;
		res!.PaymentMode = pagamento.TipoPagamento;

		dispatch(setResoultPrenotazione(res));
		GoToPage(PagesEnum.ReservationForm, formStep.ResultPrenotazione);
	};

	const OnPayPalPaymentDone = async (pagamento: IPagamento) => {
		const props: IPaymentSendRequest = {
			Success: pagamento.Success,
			Skipped: pagamento.Skipped,
			TransactionID: pagamento.TransactionID,
			culture: i18n.language,
			IdSessione: sessionInfo.sessione?.idSessione,
			step: sessionInfo.step as number,
			IdPreventivo: dataForm?.resultPrenotazione?.ResPrenotazione?.IdPreventivo ?? preventivoData?.IdPreventivo,
			PaymentMode: pagamento.TipoPagamento,
		};

		try {
			const paymentSuccess = await AssistitoRepository.PaymentSend(props);

			let res: IResultPrenotazioneDataSlice = { ...dataForm!.resultPrenotazione };
			res!.PaymentMode = pagamento.TipoPagamento;
			res!.PaymentSuccess = paymentSuccess?.Result;
			res!.ResPrenotazione = dataForm?.resultPrenotazione?.ResPrenotazione;
			res!.IdTransazione = pagamento.TransactionID;

			dispatch(setResoultPrenotazione(res));

			OnFinishSession(sessionInfo.step as number, true);
		} catch (err: any) {
			let res = { ...dataForm?.resultPrenotazione };
			if (res === undefined) {
				res = {
					PaymentSuccess: false,
					ResPrenotazione: dataForm?.resultPrenotazione?.ResPrenotazione,
					IdTransazione: pagamento.TransactionID,
				} as IResultPrenotazioneDataSlice;
			} else {
				res.PaymentSuccess = false;
				res.ResPrenotazione = dataForm?.resultPrenotazione?.ResPrenotazione;
				res.IdTransazione = pagamento.TransactionID;
			}
			dispatch(setResoultPrenotazione(res));
		}

		GoToPage(PagesEnum.ReservationForm, formStep.ResultPrenotazione, { pageSender: getSender() });
	};

	const onModalitaPagamentoSubmit = async (formData: IModalitaPagamentoForm) => {
		setPaymentMode(formData.pagamento);
	};

	return (
		<div id="pagamento">
			<div className="title item pagamento-title">
				<span>{t("pagamento.title")}</span>
				<Riepilogo nuovaPrenotazione={newPrenotazione} />
			</div>
			<Spin spinning={paying}>
				<Skeleton loading={loading}>
					<>
						{!paymentMode ? (
							<SceltaModalitaPagamento
								BackButtonVisible={false}
								OnSubmit={onModalitaPagamentoSubmit}
								NuovaPrenotazione={newPrenotazione}
							></SceltaModalitaPagamento>
						) : (
							<>
								<div className="subtitle item pagamento-title">
									<span>{t("pagamento.importo")}</span>
									<span>
										{preventivoData?.ImportoScontatoConIva.toLocaleString(
											undefined, // leave undefined to use the visitor's browser
											// locale or a string like 'en-US' to override it.
											{ style: "currency", currency: "EUR" }
										)}
									</span>
									{(preventivoData?.Sconto ?? 0) > 0 && (
										<>
											<div className="flexBr"></div>
											<span>{t("pagamento.sconto")}</span> <span> {preventivoData?.Sconto + "%"}</span>
										</>
									)}
									{(preventivoData?.Bollo ?? 0) > 0 && (
										<>
											<div className="flexBr"></div>
											<span>{t("pagamento.bollo")}</span>
											<span>
												{preventivoData?.Bollo.toLocaleString(
													undefined, // leave undefined to use the visitor's browser
													// locale or a string like 'en-US' to override it.
													{ style: "currency", currency: "EUR" }
												)}
											</span>
										</>
									)}
									<div className="flexBr"></div>
									<hr style={{ width: "100%" }} />
									{
										<>
											<div className="flexBr"></div>
											<span>{t("pagamento.totale")}</span>
											<span>
												{((preventivoData?.ImportoScontatoConIva ?? 0) + (preventivoData?.Bollo ?? 0)).toLocaleString(
													undefined, // leave undefined to use the visitor's browser
													// locale or a string like 'en-US' to override it.
													{ style: "currency", currency: "EUR" }
												)}
											</span>
										</>
									}
								</div>
								<br />
								{newPrenotazione && (
									<>
										<span className={" text prenotazione-avvenuta"}>{t("pagamento.booking")}</span>
										<br />
									</>
								)}

								<GestionePagamenti
									SetPaying={setPaying}
									PreventivoData={preventivoData}
									PaymentModeSelected={paymentMode}
									OnPayPalPaymentDone={OnPayPalPaymentDone}
									OnStrypePaymentDone={OnStrypePaymentDone}
									OnSwitchPaymentMode={() => {
										setPaymentMode(undefined);
										window.scrollTo({ top: 0, behavior: "smooth" });
									}}
								></GestionePagamenti>
							</>
						)}
					</>
				</Skeleton>{" "}
			</Spin>
		</div>
	);
};

export default Enhanced( Pagamento,{componentNamespace:"Pagamento"});
